export type TrailWork = {
  order: number
  title: string
  composer: string
  audioUrl?: string
  attribution?: string
  license?: string
  image?: string
}

export const TRAIL_NAME = 'Clássicos dos Clássicos'

// Lista completa em 01-docs/03-trilhas.md. Só a obra em CURRENT_TRAIL_ORDER tem o ciclo de três
// encontros de verdade (backend semeado). Algumas outras já têm audioUrl (áudio baixado do Musopen,
// arquivo em public/audio/trilha/) e por isso mostram um preview simples ao clicar — mas ainda não
// têm trilha/schema por trás, então continuam bloqueadas para o ciclo completo até esse backend existir.
export const TRAIL_WORKS: TrailWork[] = [
  { order: 1, title: 'As Quatro Estações', composer: 'Antonio Vivaldi', image: '/images/trilha/01-quatro-estacoes.png' },
  { order: 2, title: 'Clair de Lune', composer: 'Claude Debussy', image: '/images/trilha/02-clair-de-lune.png' },
  { order: 3, title: 'Lago dos Cisnes', composer: 'Piotr Ilitch Tchaikovsky', image: '/images/trilha/03-lago-dos-cisnes.png' },
  { order: 4, title: 'Quinta Sinfonia', composer: 'Ludwig van Beethoven', image: '/images/trilha/04-quinta-sinfonia.png' },
  { order: 5, title: 'Concerto para Piano nº 21', composer: 'Wolfgang Amadeus Mozart', image: '/images/trilha/05-concerto-piano-21.png' },
  {
    order: 6, title: 'O Moldava', composer: 'Bedřich Smetana',
    audioUrl: '/audio/trilha/06-o-moldava.mp3',
    attribution: 'Czech National Symphony Orchestra',
    license: 'Domínio público · Musopen',
    image: '/images/trilha/06-o-moldava.png',
  },
  { order: 7, title: 'Noturno', composer: 'Frédéric Chopin', image: '/images/trilha/07-noturno.png' },
  { order: 8, title: 'A Flauta Mágica', composer: 'Wolfgang Amadeus Mozart', image: '/images/trilha/08-a-flauta-magica.png' },
  { order: 9, title: 'Carmen', composer: 'Georges Bizet', image: '/images/trilha/09-carmen.png' },
  { order: 10, title: 'Nona Sinfonia', composer: 'Ludwig van Beethoven', image: '/images/trilha/10-nona-sinfonia.png' },
  {
    order: 11, title: 'Abertura 1812', composer: 'Piotr Ilitch Tchaikovsky',
    audioUrl: '/audio/trilha/11-abertura-1812.mp3',
    attribution: 'Skidmore College Orchestra',
    license: 'Domínio público · Musopen',
    image: '/images/trilha/11-abertura-1812.png',
  },
  { order: 12, title: 'Cantata nº 147', composer: 'Johann Sebastian Bach', image: '/images/trilha/12-cantata-147.png' },
  { order: 13, title: 'Sexta Sinfonia', composer: 'Ludwig van Beethoven', image: '/images/trilha/13-sexta-sinfonia.png' },
  { order: 14, title: 'Quinteto "A Truta"', composer: 'Franz Schubert', image: '/images/trilha/14-quinteto-a-truta.png' },
  { order: 15, title: 'Concertos para Flauta nº 1 e nº 2', composer: 'Wolfgang Amadeus Mozart', image: '/images/trilha/15-concertos-flauta.png' },
  { order: 16, title: 'Arabescos', composer: 'Claude Debussy', image: '/images/trilha/16-arabescos.png' },
  { order: 17, title: 'Suítes para Violoncelo', composer: 'Johann Sebastian Bach', image: '/images/trilha/17-suites-violoncelo.png' },
  { order: 18, title: 'Oratório O Messias', composer: 'Georg Friedrich Händel', image: '/images/trilha/18-oratorio-messias.png' },
  { order: 19, title: 'Réquiem', composer: 'Wolfgang Amadeus Mozart', image: '/images/trilha/19-requiem.png' },
  { order: 20, title: 'Variações Goldberg', composer: 'Johann Sebastian Bach', image: '/images/trilha/20-variacoes-goldberg.png' },
  { order: 21, title: 'Os 24 Caprichos para Violino Solo', composer: 'Niccolò Paganini', image: '/images/trilha/21-caprichos-violino.png' },
  { order: 22, title: 'O Cravo Bem Temperado', composer: 'Johann Sebastian Bach', image: '/images/trilha/22-cravo-bem-temperado.png' },
  { order: 23, title: 'Os Madrigais', composer: 'Claudio Monteverdi', image: '/images/trilha/23-madrigais.png' },
  { order: 24, title: 'Prelúdio de Parsifal', composer: 'Richard Wagner', image: '/images/trilha/24-preludio-parsifal.png' },
  { order: 25, title: 'Cenas Infantis (Kinderszenen)', composer: 'Robert Schumann', image: '/images/trilha/25-cenas-infantis.png' },
]

export const CURRENT_TRAIL_ORDER = 4
